import React, { useState } from 'react';
import { useSession } from 'next-auth/react';
import '/public/css/pages/forYou.css';
import ForYouSubNav from 'components/ForYouSubNav/ForYouSubNav';
import config from 'config/followcollections.json';
import AddFavoriteWrapper from 'components/Data/AddFavoriteWrapper';
import IconBookmark from 'components/Icons/IconBookmark';
import IconClose from 'components/Icons/IconClose';

const Following = () => {
  const sessionData = useSession();
  const session = sessionData.data;
  const isLoggedIn = Boolean(session?.user);
  const [categories, setCategories] = useState(config);

  if (!isLoggedIn) {
    return (
      <div className="for-you-container">
        <ForYouSubNav />
        <div>Please log in to view your favorites.</div>
      </div>
    );
  } else {
    return (
      <div className="for-you-container">
        <ForYouSubNav />
        <div className="for-you for-you-categories">
          <div className="container">
            <main>
              <div id="mainContent"></div>
              <div className="for-you-welcome">
                <h2>Your Categories</h2>
              </div>
              <p>
                Add or remove categories based on your preferences. Changes will
                be reflected in your feed.
              </p>
              <ul className="grid-3col-list for-you-categories">
                {categories.map((category) => {
                  return (
                    <li key={category.id} className="for-you-category">
                      <AddFavoriteWrapper
                        key={category.id}
                        title={category.name}
                        contentArea={process.env.CONTENT_AREA_SLUG || 'mprnews'}
                        resourceType="collection"
                        id={category.id}
                        SaveEle={
                          <div className="for-you-category-label">
                            <span>{category.name}</span>
                            <IconBookmark color="currentColor" />
                          </div>
                        }
                        SavedEle={
                          <div className="for-you-category-label">
                            <span>{category.name}</span>
                            <IconClose color="currentColor" />
                          </div>
                        }
                        showIcon={false}
                      />
                    </li>
                  );
                })}
              </ul>
            </main>
          </div>
        </div>
      </div>
    );
  }
};

export default Following;
